import { OptimizedSearchResponse, SeoLocationSchema } from '@rover/rsdk/src/apiClient/latest';
import { SeoSlugEnum, SERVICE_TYPE_FOR_SEO_SLUG } from '@rover/shared/js/constants/seo';
import { PetType } from '@rover/types/src/Pet';
import {
  PET_TYPE_FOR_SERVICE_LANDING_ENUM,
  ServiceLandingEnum,
} from '@rover/types/src/ServiceLanding';

import { LandingSearchFormFilters } from '../components/LandingSearchForm';

export const getSearchFiltersFromSearchResults = (
  serviceLandingType: ServiceLandingEnum,
  searchResults?: OptimizedSearchResponse
): LandingSearchFormFilters => {
  return {
    serviceType: SERVICE_TYPE_FOR_SEO_SLUG[serviceLandingType],
    locationType: searchResults?.derivedData?.zipCode ? 'zip-code' : undefined,
    location: searchResults?.derivedData?.zipCode as string,
    centerlat: searchResults?.derivedData?.center
      ? searchResults?.derivedData?.center[0]
      : undefined,
    centerlng: searchResults?.derivedData?.center
      ? searchResults?.derivedData?.center[1]
      : undefined,
    petType: PET_TYPE_FOR_SERVICE_LANDING_ENUM[serviceLandingType],
  };
};

export function getSearchFiltersFromSeoLocationDetails(
  seoLocation: SeoLocationSchema
): LandingSearchFormFilters {
  const { localityType, details: seoLocationDetails } = seoLocation;

  return {
    serviceType: SERVICE_TYPE_FOR_SEO_SLUG[seoLocationDetails.serviceTypeSlug],
    locationType: localityType,
    location: seoLocationDetails.locality.seoDisplayName,
    centerlat: parseFloat(seoLocationDetails.locality.latitude),
    centerlng: parseFloat(seoLocationDetails.locality.longitude),
    petType: [
      seoLocationDetails.serviceTypeSlug === SeoSlugEnum.CAT_SITTING ? PetType.CAT : PetType.DOG,
    ],
  };
}
